import Vue from 'vue';

class EventLoading extends Vue {
    private loadingCount: number = 0;

    startLoading() {
        this.loadingCount++;
        this.$emit('loading', this.loadingCount > 0);
    }

    stopLoading() {
        this.loadingCount = Math.max(0, this.loadingCount - 1);
        this.$emit('loading', this.loadingCount > 0);
    }
}

export var eventLoading = new EventLoading();